import { render, staticRenderFns } from "./ClientCaseView.vue?vue&type=template&id=67a25cbb&scoped=true&"
import script from "./ClientCaseView.vue?vue&type=script&lang=js&"
export * from "./ClientCaseView.vue?vue&type=script&lang=js&"
import style0 from "./ClientCaseView.vue?vue&type=style&index=0&id=67a25cbb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a25cbb",
  null
  
)

export default component.exports